<template>
  <div class="exhibitionList" id="guestListDiv">
    <el-col class="infoPub" style="width: 990px">
      <!-- <div class="total-data" v-if="userInfo.user_admin_state == 1">
        <span>{{language.bbsForumAccount}}：{{totalData.bbs_count}}</span>
        <span>{{language.bbsForumLive}}：{{totalData.play_count}}</span>
        <span>{{language.bbsForumNowNum}}：{{totalData.user_count}}</span>
      </div> -->
      <!-- <div class="content-title" v-if="lan == 'ch'">嘉宾名单</div>
      <div class="content-title" v-else>GuestsList</div> -->
      <!-- 列表组件 -->
      <!--搜索框-->
      <div :class=" userInfo.user_nature == 3 ? 'search-content' : 'search-contentPer'">
        <el-form style="margin-top: 5px;" v-if="userInfo.user_nature == 3">
          <el-form-item style="position: relative;">
            <el-cascader
                v-model="userInfos.classifyVal"
                :options="recruitList"
                @change="postMes"
                clearable
                placeholder="求职意向"
            >
            </el-cascader>
            <el-input
                clearable
                v-model="userInfos.location"
                v-on:click.native="showArea"
                @mouseover.native="handleOver($event)"
                @mouseout.native="handleOut($event)"
                :readonly="true"
                placeholder="意向工作地"
                ref="wordLocation1"
                style="width: 215px;margin-left: 20px;"
            ></el-input>
            <i :class="jiantou"
               @mouseover="handleOver1($event)"
               @click="clearCity"
               style="width: 20px;height: 20px; position: absolute;left: 445px;top: 12px; font-size: 14px;color: #C0C4CC"></i>
            <el-select v-model="userInfos.start_job_date" clearable
                       placeholder="工作经验">
              <el-option :value="item" v-for="item in experienceList"></el-option>
            </el-select>
            <el-select v-model="userInfos.salary"
                       clearable
                       placeholder="薪资范围">
              <el-option
                  v-for="item in salaryList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
            <el-select style="margin-top: 10px;"
                       v-model="userInfos.sex"
                       clearable
                       placeholder="性别">
              <el-option :value="item" v-for="item in gender"></el-option>
            </el-select>
            <el-input v-model="userInfos.xinxi"
                      style="width: 455px;margin-left: 20px;"
                      placeholder="姓名/年龄/手机号/邮箱"></el-input>
            <el-button style="background: #0071FF;color: #FFFFFF;width: 100px;margin-left: 20px;font-size: 16px;"
                       type="primary"
                        @click="search">搜索</el-button>
            <el-button style="width: 100px; color: #0071FF;margin-left: 16px;font-size: 16px;margin-bottom: 15px;"
            @click="clear">清除</el-button>
          </el-form-item>
        </el-form>
        <el-form style="margin-top: 4px;" v-else>
          <el-form-item style="position: relative;">
            <el-cascader
                v-model="userInfos.classifyVal"
                :options="recruitList"
                @change="postMes"
                clearable
                style="width: 189px;margin-left: 5px;"
                placeholder="招聘岗位"
            >
            </el-cascader>
            <el-input
                v-model="userInfos.location"
                v-on:click.native="showArea"
                @mouseover.native="handleOver($event)"
                @mouseout.native="handleOut($event)"
                :readonly="true"
                placeholder="招聘工作地"
                ref="wordLocation"
                class="workCity"
                style="width: 190px;margin-left: 5px;"
            ></el-input>
<!--            <i :class="areaVisible ?'el-icon-arrow-up' : 'el-icon-arrow-down'" style="width: 20px;height: 20px; position: absolute;left: 363px;top: 13px; font-size: 14px;color: #C0C4CC"></i>-->
<!--            <i class="el-icon-circle-close" style="width: 20px;position: absolute;right: 380px;top: 10px; z-index: 2;"></i>-->
            <i :class="jiantou"
                @mouseover="handleOver1($event)"
               @click="clearCity"
               style="width: 20px;height: 20px; position: absolute;left: 363px;top: 13px; font-size: 14px;color: #C0C4CC"></i>
            <el-select
                v-model="userInfos.firmQuality"
                placeholder="企业性质"
                clearable
                style="width: 190px;margin-left: 5px;"
                ref="companyXZ"
            >
              <el-option
                  v-for="item in firmQuality"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
            <el-input v-model="userInfos.companyName"
                      style="width: 189px;margin-left: 5px;"
                      placeholder="公司名称"></el-input>
            <el-button style="background: #0071FF;color: #FFFFFF;width: 85px;margin-left: 5px;font-size: 16px;"
                       type="primary"
                       @click="search">搜索</el-button>
            <el-button style="width: 85px; color: #0071FF;margin-left: 5px;background: #f2f2f2;border: none;font-size: 16px;"
                       @click="clear">清除</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="search-letter" v-if="userInfo.user_nature == 1">
        <div style="float: left;background: #edf1f5;
                    height: 20px;line-height: 20px;border-radius: 10px;color: #333333;
                    font-size: 16px;text-align: center;
                    padding: 10px 10px 10px 10px;margin-right: 20px;font-weight: bold">
          招聘岗位数量
          <span
              v-for="(item, index) in jobsNum"
              :key="index"
              style="background: #FFFFFF;padding: 1px 2px 2px;
                     font-weight: bold;margin-right: 4px;font-size: 16px;
                    box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.16);"
          >{{ item }}</span>
        </div>
        <div style="margin-top:8px;display: inline-block;float: left;">
           <span style="font-size:16px;color: #001733" >字母搜索：</span>
          <template v-if="lan == 'ch'">
          <span
              style="font-size:16px;cursor: pointer;color: #001733;margin-left: 12px;"
              v-for="(item, index) in abcSearchList"
              @click="chooseAbcSearchItem(item)"
              :class="abcString == item ? 'choose-abc-active' : ''"
              :key="index"
          >{{ item }}</span
          >
          </template>
        </div>
        <div style="clear: both;"></div>
      </div>

      <!--提示信息-->
<!--      <div class="prompt-info-wrap com-tips">-->
<!--        <div-->
<!--            class="prompt-info"-->
<!--            v-if="lan == 'ch'"-->
<!--        >-->
<!--          1、观展前，请确保您使用的参展电脑配有摄像头，耳机和麦克风设备。-->
<!--        </div>-->
<!--        <div-->
<!--            class="prompt-info"-->
<!--            v-if="lan == 'ch'"-->
<!--        >-->
<!--          2、观展时，请使用谷歌浏览器打开展会官网，如需安装，<span-->
<!--            class="download"-->
<!--            @click="download"-->
<!--        >-->
<!--              {{ language.down }}-->
<!--            </span>-->
<!--        </div>-->
<!--      </div>-->

      <!--table-->
      <div class="table-content">
        <pub-table
            :columns="userInfo.user_nature == 1 ? columnsPer : columns"
            :tableData="guestsList"
            :loading="loading1"

            :rowspan="rowspan"
            :mergeCol="mergeCol"
            :ticketMan="ticketMan"
        >
          <template v-slot:city="dataList">
            <!--            <span v-for="item in jobList">{{item}}</span>-->
            <span>{{(dataList.location).split(" ")[1]}}</span>
          </template>
          <template v-slot:email="dataList">
            <span v-if="userType==1">{{dataList.row.email}}</span>
            <div v-else>
              <div style="text-align: center;color: #464646;font-size: 16px;">如果需要招聘企业详细信息</div>
              <div style="text-align: center;color: #464646;font-size: 16px;margin-top: 10px;">请报名
                <span style="color: #3175fd">本次云聘</span></div>
              <el-button style="margin: 30px auto 0 auto;background: #3175fd;color: #FFFFFF;display: block;" @click="pay">马上报名</el-button>
            </div>
          </template>
          <template v-slot:action="dataList">
            <el-button
                size="mini"
                @click="getJoin(dataList)"
                style="outline: none;background:#0071ff;border:none;cursor:pointer;color:#fff;border-radius:5px;font-size:14px;padding: 8px 15px;"
            >{{ userInfo.user_nature == 1 ? "查看详情" : "查看简历" }}</el-button>

          </template>
        </pub-table>

      </div>

      <el-dialog
          title=""
          class="telPop"
          :visible.sync="tips"
          :destroy-on-close="true"
          width="400px"
          top="30vh"
          style="margin: 0 auto;text-align:center;z-index: 2000;border-radius: 10px;"
      >
        <div style="text-align: center;color: #464646;font-size: 16px;">如需查看简历</div>
        <div style="text-align: center;color: #464646;font-size: 16px;margin-top: 10px;">请报名
          <span style="color: #3175fd">本次云聘</span></div>
        <el-button style="margin-top: 30px;background: #3175fd;color: #FFFFFF;" @click="pay">马上报名</el-button>
      </el-dialog>

      <el-dialog
          title=""
          class="telPop"
          :visible.sync="tips2"
          :destroy-on-close="true"
          width="300px"
          top="30vh"
          style="margin: 0 auto;text-align:center;z-index: 2000;border-radius: 10px;"
      >
        <div style="text-align: center;color: #464646;font-size: 16px;margin-top: 10px;">企业信息审核后可以查看简历</div>
        <div><el-button style="margin-top: 30px;background: #3175fd;color: #FFFFFF;" @click="ok">立即完善</el-button></div>
      </el-dialog>

      <!-- page -->
      <table-page
        :pageSize="pageSize"
        :layout="layout"
        :pageTotal="pageTotal"
        :currentPage="currentPage"
        @pageChange="pageChange"
      ></table-page>
    </el-col>
    <el-dialog
        title="查看简历"
        class="resume-dialog"
        :visible.sync="showResume"
        :destroy-on-close="true"
        width="1000px"
        top="30vh"
    >

      <div style="overflow: hidden;position: relative;">
        <div class="top-line"></div>
        <online-resume ref="resumeInfo" :applicantMess="applicantMess"></online-resume>
      </div>
    </el-dialog>
    <!-- 企业详情 -->
    <company-dialog ref="companyDialog"></company-dialog>
    <!--所在城市-->
    <area-div v-model="areaName" parentId="guestListDiv" :areaEl="areaEl" :exhibition_id="exhibitionId" :userNature="userInfo.user_nature == 1 ? 3 : 1" :visible.sync="areaVisible" @areaVisibleEvent="areaVisibleEvent"/>
  </div>
</template>
<script>
import {getLanguage, language} from "../../../language/get";
import { ExhIndexType } from "../../../common/constant/exhibition";
import Cookie from "../../../common/cookie";
import searchBar from "../components/searchbar/searchbar";
import bbsList from "../components/bbslist/bbslist";
import tablePage from "../components/tablepage/tablepage";
import { isEmpty, isInternet } from "../../../common/validate";
import { roomUrl, windowsGoTo } from "../../../common/url";
import dialogPub from "../components/dialogpub/dialogpub";
const pubLanguage = language();
import downloadDialog from "../../../components/DownloadDialog/index";
import getParamter from "../../../common/util";
import {getguestsList, selectRecruitPost, getJobFairNum, selectList, getCompanysList} from "../../../api/exhibition";
import { mapGetters } from "vuex";
import { getLiveUrl, getCountryState } from "../../../api/forum";
import {findUserDetails, getUserInfo} from "../../../api/user";
import { MessageBox } from 'element-ui';
import pubTable from "../components/table/table"
import areaDiv from  "@/components/area/index";
import axios from "axios";
import guestsList from "@/pages/forum/guestsList";
import companyDialog from "@/pages/forum/companyDialog";
import onlineResume from "@/pages/user/onlineResume/resumeInfo";

const initialization = {
  broadcast_id: "",
  broadcast_class_id: "",
  broadcast_name: "",
  broadcast_name_en: "",
  location: "",
  location_en: "",
  broadcast_name1: "",
  user_post: "",
  user_post_en: "",
  truename: "",
  truename_en: "",
  broadcast_class_name: "",
  tel: "",
  broadcast_introduce: "",
  broadcast_introduce_en: "",
  broadcast_logo: null,
  broadcast_applent_logo: null,
};
export default {
  components: {
    companyDialog,
    searchBar,
    bbsList,
    tablePage,
    downloadDialog,
    dialogPub,
    onlineResume,
    pubTable,
    areaDiv
  },
  computed: {
    ...mapGetters(["token", "userInfo"]),
  },
  data() {
    return {
      lastRequestParams:{},
      areaVisible: false,
      areaName: '',
      areaEl: null,
      mergeCol: -1,
      rowspan: 1,
      loading1:true,
      ticketMan: true,
      userInfos: {
        classifyVal:"",
        location: "",
        start_job_date: "",
        companyName:"",
        salary:"",
        sex:"",
        xinxi:"",
        firmQuality:"",
      },
      jiantou:"el-icon-arrow-down",  //箭头
      applicantMess:null, //应聘者信息
      tips:false,
      tips2:false,
      showResume: false,
      recruitList:[], // 求职意向
      jobsNum:null, //招聘岗位数量
      abcString: "", //字母搜索
      gender:["男", "女"],
      abcSearchList: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "全部",
      ],
      //企业性质
      firmQuality:[
        {
          value:'0',
          label:getLanguage().companyProperty1
        },{
          value:'1',
          label:getLanguage().companyProperty2
        },{
          value:'2',
          label:getLanguage().companyProperty3
        },{
          value:'3',
          label:getLanguage().companyProperty4
        },{
          value:'4',
          label:getLanguage().companyProperty5
        },{
          value:'5',
          label:getLanguage().companyProperty6
        }],
      salaryList:[
        {
          value:'1K-3K',
          label:"1K-3K"
        },{
          value:'3K-5K',
          label:"3K-5K"
        },{
          value:'5K-8K',
          label:"5K-8K"
        },{
          value:'8K-12K',
          label:"8K-12K"
        },{
          value:'12K以上',
          label:"12K以上"
        },
      ],
      //table 表头 企业
      columns: [
        {
          title: pubLanguage.username,
          key: "true_name",
          width: "160",
        },
        {
          title: pubLanguage.home,
          key: "city",
          width: "160",
        },
        {
          title: pubLanguage.edu,
          key: "education_name",
          width: "160",
        },
        {
          title: pubLanguage.workExperience,
          key: "start_job_date",
          width: "160",
        },
        {
          title: pubLanguage.liveClass2,
          key: "jobNames",
          width: "160",
        },
        {
          title: pubLanguage.operation,
          key: "action",
          width: "168",
        },
      ],
      //table 表头 个人
      columnsPer: [
        {
          title: pubLanguage.guestscompanyName,
          key: "company",
          width: "192",
        },
        {
          title: pubLanguage.guestscompanyXZ,
          key: "natureVal",
          width: "194",
        },
        {
          title: pubLanguage.home,
          key: "city",
          width: "194",
        },
        {
          title: pubLanguage.email,
          key: "email",
          width: "194",
        },
        {
          title: pubLanguage.operation,
          key: "action",
          width: "194",
        },
      ],
      experienceList:['应届毕业生','1年以下','1-2年','2-3年','3-4年','4-5年','5年以上'],
      com:['国有企业','民营企业','合资企业','外资企业','个人独资企业','其他'],
      loading: "true",
      exhibitionId: this.$route.query.exhibition_id,
      userType: this.$route.query.user_type,
      exhibitionStatus:null, //招聘会的状态
      downloadShow: false,
      ExhIndexType,
      imgList: [],
      language: language(),
      lan: Cookie.get("lang"),
      //page
      pageTotal: 0,
      pageSize: 6,
      currentPage: 1,
      layout: "prev, pager, next, jumper",

      guestsList: [],
      jobList:[], //求职意向数组
      jobList1:"",

      showGuestsTabsTable: "0",
      guestsTabsTableType: "1",
    };
  },
  created() {
    this.getCountryStateApi();
    this.getList();
    this.selectPost();
    this.jobNum();
    this.selectJobFair();
  },
  mounted() {

  },
  methods: {
    //鼠标移入事件
    handleOver(e) {
      // console.log("移入" , e);
      if(this.userInfo.user_nature == 1) {
        if(this.$refs.wordLocation.value != undefined && this.userInfos.location != "") {
          console.log(this.$refs.wordLocation);
          this.jiantou = "el-icon-circle-close";
        }else{
          this.jiantou = "el-icon-arrow-down";
        }
      }else {
        if(this.$refs.wordLocation1.value != undefined && this.userInfos.location != "") {
          console.log(this.$refs.wordLocation1);
          this.jiantou = "el-icon-circle-close";
        }else{
          this.jiantou = "el-icon-arrow-down";
        }
      }

    },
    handleOver1(e) {
      if(this.userInfo.user_nature == 1) {
        if(this.$refs.wordLocation.value != undefined && this.userInfos.location != "" && this.jiantou == "el-icon-arrow-down"){
          this.jiantou = "el-icon-circle-close"
        }else {
          this.jiantou = "el-icon-arrow-down"
        }
      }else {
        if(this.$refs.wordLocation1.value != undefined && this.userInfos.location != "" && this.jiantou == "el-icon-arrow-down"){
          this.jiantou = "el-icon-circle-close"
        }else {
          this.jiantou = "el-icon-arrow-down"
        }
      }


    },
    clearCity(){
      if(this.userInfo.user_nature == 1) {
        if(this.$refs.wordLocation.value != undefined || this.jiantou == "el-icon-circle-close") {
          // this.$refs.wordLocation.value = "";
          this.userInfos.location = "";
        }
      }else {
        if(this.$refs.wordLocation1.value != undefined || this.jiantou == "el-icon-circle-close") {
          // this.$refs.wordLocation1.value = "";
          this.userInfos.location = "";
        }
      }

    },
    //鼠标移出事件
    handleOut(e) {
      if(this.areaVisible){
        this.jiantou = "el-icon-arrow-up";
      }else{
        this.jiantou = "el-icon-arrow-down";
      }

    },
    //查看招聘会的状态
    selectJobFair() {
      selectList({exhibition_id:this.exhibitionId}).then((res)=> {
        this.exhibitionStatus = res.data[0].exh_status;
        // this.exhibitionStatus = "3";
        // console.log("00940===" , res.data[0].exh_status);
      })
    },
    chooseAbcSearchItem(item) {
      this.abcString = item;
      // console.log(this.abcString);
      let data = {
        abc:this.abcString == '全部' ? '' : this.abcString,
        exhibition_id: this.exhibitionId,
        broadcast_type: "5",
        currentPage: this.currentPage,
        numberPage: this.pageSize,
        lg: this.lan == "ch" ? "zh" : "en",
        user: this.userInfo.user,
        user_nature: this.userInfo.user_nature == 1 ? '3' : '1'
      };
      this.getTableData(data);

    },
    jobNum() {
      //获取招聘会岗位数量
      getJobFairNum({ exhibition_id: this.exhibitionId }).then((res)=> {
        if(res.type == 1){
          this.jobsNum = res.data[0].count;
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.lastRequestParams.currentPage = 1;
      if(this.userInfo.user_nature == 3) {
        // console.log("性别=" + this.userInfos.sex)
        let gender = null;
        if(this.userInfos.sex == "男") {
          gender = '1';
        }else if(this.userInfos.sex == "女") {
          gender = '2';
        }
        let data = {
          jobId:this.userInfos.classifyVal,
          city:this.userInfos.location,
          start_job_date:this.userInfos.start_job_date,
          salary:this.userInfos.salary,
          sex:gender,
          keyword:this.userInfos.xinxi,
          exhibition_id: this.exhibitionId,
          broadcast_type: "5",
          currentPage: this.currentPage,
          numberPage: this.pageSize,
          lg: this.lan == "ch" ? "zh" : "en",
          user: this.userInfo.user,
          user_nature: this.userInfo.user_nature == 1 ? '3' : '1'
        };
        this.getTableData(data);
      }else {
        let data = {
          keyword:this.userInfos.companyName,
          locationName:this.userInfos.location,
          jobId:this.userInfos.classifyVal,
          nature:this.userInfos.firmQuality,
          exhibition_id: this.exhibitionId,
          broadcast_type: "5",
          currentPage: this.currentPage,
          numberPage: this.pageSize,
          lg: this.lan == "ch" ? "zh" : "en",
          user: this.userInfo.user,
          user_nature: this.userInfo.user_nature == 1 ? '3' : '1'
        };
        // this.getTableData(data);
        this.getTablePer(data);
      }
    },
    clear() {

      this.currentPage = 1;
      this.lastRequestParams.currentPage = 1;
      //清空数据
      this.userInfos.classifyVal = "";
      this.userInfos.location = "";
      this.userInfos.start_job_date = "";
      this.userInfos.salary = "";
      this.userInfos.sex = "";
      this.userInfos.xinxi = "";
      // this.$refs.wordLocation.value = "";
      this.userInfos.firmQuality = "";
      this.userInfos.companyName = "";
      this.abcString = "";
      // console.log(this.userInfos.location);
      this.getList();
    },
    areaVisibleEvent(visible){
      this.areaVisible = visible;
      this.userInfos.location = this.areaName;
      if(this.areaVisible) {
        this.jiantou = "el-icon-arrow-up";
      }else {
        this.jiantou = "el-icon-arrow-down";
      }
    },
    showArea(e){
      this.areaEl = e.target;
      this.areaName = this.userInfos.location;
      this.areaVisible = true;
      if(this.areaVisible) {
        this.jiantou = "el-icon-arrow-up";
      }else {
        this.jiantou = "el-icon-arrow-down";
      }
    },
    //获取表格数据  个人
    getTablePer(data){
      this.lastRequestParams = data;
      getCompanysList(data).then((res) => {
        if(res.type == "1"){
          if (!res.data) {
            this.guestsList = [];
            this.loading1 = false;
            return false;
          }
          // console.log("userType=======" + this.userType);
          if(res.data && res.data.length > 0){
            // let item = res.data[0];
            if(this.userType != 1){
              this.mergeCol = 3;
              this.rowspan = res.data.length;
            }
          }
          for (var i = 0; i < res.data.length; i++) {
            res.data[i].natureVal = this.com[res.data[i].nature];
          }
          this.guestsList = res.data;
          this.loading1 = false;
          this.pageTotal = res.datacount * 1;
            // console.log("个人表格信息==" , res);
          console.log(this.pageTotal);
        }else {
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }
      });
    },
    //获取表格数据  企业
    getTableData(data) {
      this.lastRequestParams = data;
      getguestsList(data).then((res) => {
        if (res.type == "1") {
          if (!res.data) {
            this.guestsList = [];
            this.loading1 = false;
            return false;
          }
          if(this.userInfo.user_nature==1){
            if(res.data && res.data.length > 0){
              let item = res.data[0];
              if(item.user_type != 1){
                this.mergeCol = 3;
                this.rowspan = res.data.length;
              }
            }
          }
          for (var i = 0; i < res.data.length; i++) {
            res.data[i].natureVal = this.com[res.data[i].nature];
          }

          this.guestsList = res.data;
          this.loading1 = false;
          // console.log(this.loading + "fffff", this.guestsList);

          this.pageTotal = res.datacount * 1;
          console.log(this.pageTotal);
        } else {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({ message: res.text, offset: height });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
      });
    },
    postMes(value){
      // console.log("改变==" + value)
      if(value != undefined){
        this.userInfos.classifyVal = value[1];
      }
    },
    selectPost() {
      //获取招聘岗位
      let data = {
        exhibition_id: this.exhibitionId,
        user_nature:this.userInfo.user_nature == 1 ? '3' : '1'
      }
      selectRecruitPost(data).then((res) => {
        if(res.type == 1){
          const data = res.data;
          // console.log("data：", data);
          for(var index in data) {
            if (data[index].super_id == null) {
              this.recruitList.push({
                value: data[index].id,
                label: data[index].name,
                children: []
              })
            }
          }
          for(var index in data){
            if(data[index].super_id != null){
              for(var i in this.recruitList){
                if(this.recruitList[i].value == data[index].super_id){
                  // this.$set(this.recruitList[i],"children",data[index])
                  this.recruitList[i].children.push({
                    value:data[index].id,
                    label:data[index].name,
                    super_id:data[index].super_id
                  })
                }
              }
            }
          }
          // console.log("岗位：" , this.recruitList);
        }else{
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }
      });
    },
    pay(){
      localStorage.setItem("buyBackUrl", location.href);
      let _this = this;
      let encodeData = window.btoa(window.encodeURIComponent("signUp=1&exhibitionId=" + _this.exhibitionId));
      window.location.href = "ticketsRegister.html?" + encodeData;
    },
    getJoin(val) {
      // console.log("页==" , val);
      // val.dataList.user_type = 2;
      if(this.userInfo.user_nature == 3) {
        //企业
        if(val.dataList.user_type != 1) {
          //购买门票
          this.tips = true;
        }else{
          getUserInfo().then((res)=> {
            if(res.type != 1) {
              const height = document.body.clientHeight / 2;
              return this.$message.error({message: res.text, offset: height,});
            }else {
              console.log("简历=" , res.data[0]);
              if(res.data[0].check_status != 1) {
                this.tips2 = true;
                // this.$message.error({message:"企业信息审核后可以查看简历" , offset:200})
              }else{
                //查看简历
                this.showOnlineResume(val.dataList.user_id);
              }
            }
          });

        }
      }else{
        //个人
        this.$refs.companyDialog.showUpParticipants([{
          user_id: val.dataList.user_id,
          ExhibitionId: val.dataList.ExhibitionId,
        },0],this.userInfos.classifyVal);
      }


    },
    ok() {
      this.tips2 = false;
      window.location.href="user.html";
    },
    showOnlineResume(user_id){
      let data = {
        token: this.$store.state.user.token,
        user_id: user_id
      };
      findUserDetails(data).then(res => {
        if (res.type == '1') {
          this.applicantMess = res.data[0];
          this.showResume = true;
          this.$refs.resumeInfo.loadData(res.data[0]);
        }
      });
    },
    //下载谷歌浏览器
    download() {
      window.open(
          "https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds"
      );
    },
    detailsClick(){
      let _this = this;
      MessageBox({
        title: "",
        message: this.lan=='ch'?"报名后可见":"Registration visible",
        confirmButtonText: language().apply,
        cancelButtonText: language().cancel,
        showCancelButton: true,
        // type: 'success'
      }).then(() => {
        //确认
        localStorage.setItem("buyBackUrl", location.href);
        let encodeData = window.btoa(window.encodeURIComponent("signUp=1&exhibitionId=" + _this.exhibitionId));
        window.location.href = "ticketsRegister.html?" + encodeData;
      }).catch(() => {
        //取消
      });
    },
    //获取显示国内外展商
    getCountryStateApi() {
      let props = {
        exhibition_id: this.exhibitionId,
      };
      getCountryState(props).then((res) => {
        console.log(res.data);
        this.showGuestsTabsTable = res.data.jiabin;
        if (this.showGuestsTabsTable == "0") {
          this.guestsTabsTableType = "";
        }
        this.getList();
      });
    },
    changeGuestsTabsTable(type) {
      this.guestsTabsTableType = type;
      this.getList();
    },
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.lastRequestParams.currentPage = val;
      this.getList(true);
    },
    getList(flag) {
      let that = this;

      let data = {
        exhibition_id: this.exhibitionId,
        broadcast_type: "5",
        currentPage: this.currentPage,
        numberPage: this.pageSize,
        lg: this.lan == "ch" ? "zh" : "en",
        user: this.userInfo.user,
        user_nature: this.userInfo.user_nature == 1 ? '3' : '1',
      };

      // super_user_id:this.userInfo.user
      //判断是否是子账号
      // console.log("值==" , this.userInfo);
      // if(this.userInfo.superioruser_id != 0){
      //   alert(11);
      //   data.super_user_id = this.userInfo.super_user_id;
      // }

      if(this.userInfo.user_nature == 1) {
        if(!flag){
          this.getTablePer(data);
        }else{
          this.getTablePer(this.lastRequestParams);
        }
      }else {
        if(!flag){
          this.getTableData(data);
        }else{
          this.getTableData(this.lastRequestParams);
        }
      }

    },
  },
};
</script>
<style>
  .resume-dialog .top-line{
    border-top: 1px solid #EEEEEE;
    margin: 0px 20px;
  }
  .resume-dialog .el-dialog__headerbtn .el-dialog__close {
    width: 20px !important;
    height: 20px !important;
    color: #fff !important;
    background: #0c6dce !important;
    /* padding: 1px !important; */
    border-radius: 50% !important;
    line-height: 20px !important;
  }
  .resume-dialog .el-dialog__title {
    font-weight: bold;
    padding-left: 20px;
  }
  .resume-dialog .el-dialog__body {
    padding-top: 0px;
  }
</style>
<style scoped>

.el-form-item {
  margin-bottom: 0;
}
.content {
  height: 660px;
  /* background: #ffffff; */
  padding: 0 10px;
  margin: 0 auto;
}
.content1 {
  height: 650px;
  overflow-y: auto;
  background: #ffffff;
  padding: 0 10px;
  margin: 0 auto;
}
.small-content {
  height: 640px;
  /* background: #ffffff; */
  padding: 0 10px;
  margin: 0 auto;
}
.content-title {
  height: 20px;
  line-height: 20px;
  border-bottom: 1px solid #cccccc;
  padding: 10px 20px;
  font-size: 14px;
}
.guestsList-wrap {
  background: #ffffff;
  float: left;
  width: 32%;
  height: 310px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 2%;
  position: relative;
  border-radius: 5px;
}

.guestsList-wrap1 {
  background: #ffffff;
  float: left;
  width: 32%;
  height: 270px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 2%;
  position: relative;
}
.guestsList-wrap:nth-child(3n-1) {
  margin: 0 2% 2%;
}
.guestsList-wrap1:nth-child(3n-1) {
  margin: 0 2% 2%;
}
.guestsList-wrap-top {
  margin: 30px auto 0;
  width: 85%;
  /* border-bottom: 1px solid #d8d8d8; */
}
.guestsList-wrap-top-name {
  display: inline-block;
  font-size: 26px;
  min-height: 15px;
  margin: 20px 10px 10px 0px;
  word-break: break-word;
  color: #0b8afd;
}
.guestsList-wrap-top-position {
  font-size: 16px;
  margin: 20px 0px 10px 0px;
  color: #0b8afd;
}
.guestsList-wrap-content {
  margin: 10px auto 0;
  width: 90%;
  min-height: 150px;
  background: #f6f6f6;

}

.guestsList-wrap-content-companyName {
  min-height: 42px;
  color: #333;
  font-size: 16px;
  padding: 15px 20px;
}
.guestsList-wrap-content-address {
  color: #8e8e8e;
  font-size: 14px;
  /* padding-bottom: 4px; */
  padding: 0 20px 4px;
}
.guestsList-wrap-content-tel {
  color: #8e8e8e;
  font-size: 14px;
  /* padding-bottom: 4px; */
  padding: 0 20px 4px;
}
.guestsList-wrap-content-tel-en {
  color: #8e8e8e;
  font-size: 14px;
  /* padding-top: 15px;
    padding-bottom: 4px; */
  padding: 15px 20px 4px;
}
.guestsList-wrap-content-Email {
  color: #8e8e8e;
  font-size: 14px;
  display: inline-block;
  padding: 0 20px;
  margin-bottom: 20px;
  white-space: nowrap;
}
.guestsList-wrap-content-footer {
  position: absolute;
  bottom: 20px;
  right: 10px;
  display: inline-block;
}

.guestsList-top-right-gz {
  height: 35px;
  background: linear-gradient(to top left, #41d0fe, #055ee8);
  background-size: 100% 100%;
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
  padding: 0 5px 0 20px;
  position: absolute;
  top: 20px;
  right: 0px;
}
.guestsList-top-right-cz {
  height: 35px;
  background: linear-gradient(to top left, #f2a166, #f06626);
  background-size: 100% 100%;
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
  padding: 0 5px 0 20px;
  position: absolute;
  top: 20px;
  right: 0px;
}
.guestsList-top-right-title {
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  color: #fff;
}

.guestsList-top-left-wiffa {
  width: 74px;
  height: 20px;
  /* background-image: url('../../../assets/icon_gz_bg.png');
    background-repeat:no-repeat;
    background-size: 100% 100%;
    border-bottom-left-radius: 20px; */
  position: absolute;
  top: 0;
  left: 0;
}
.guestsList-top-left-wiffa img {
  width: 100%;
  height: 100%;
}
.guestsList-wrap-content-img {
  width: 74px;
  height: 20px;
}

.guests_tabs_table {
  height: 42px;
  margin: 10px 0;
  overflow: hidden;
  color: #000;
  position: relative;
  /* overflow: auto; */
}
.guests_tabs_table_btn {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
}
.guests_tabs_table_btn div {
  float: left;
  padding: 11px 10px !important;
  margin: 0 30px;
  cursor: pointer;
}
.guests_tabs_table_active {
  padding: 11px 10px !important;
  margin: 0 30px;
  background: #0f408a !important;
  color: #fff !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.guests_tabs_table_left_active {
  padding: 11px 10px !important;
  margin: 0 30px;
  /* background: #0f408a !important; */
  color: #000 !important;
  font-size: 20px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 4px solid #ef6a28;
}
.guests_tabs_table_left {
  font-size: 20px;
}

.guests_tabs_table_conter {
  font-size: 20px;
}

.guests_tabs_table_right {
  font-size: 20px;
}
.guests_tabs_table_bg {
  width: 100%;
  height: 39px;
  /* background: #eeeeee; */
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 0;
  /* border-bottom: 1px solid #ccc; */
  border-bottom: 1px solid #0f408a;
}

</style>
<style>
.bbsdialog .el-dialog {
  max-height: none;
}
.el-upload-list--picture-card .el-upload-list__item-status-label i {
  margin-top: 6px;
}
.bbsdialog .el-dialog__header {
  position: relative;
}
.bbsdialog .el-dialog__headerbtn {
  top: 4px;
}
.total-data {
  background: #ffffff;
  font-size: 18px;
  color: #434343;
  padding: 14px 10px;
}
.total-data > span {
  margin-right: 40px;
}
.dislogCon {
  text-align: center;
}
.img-formBtn {
  margin: 0 auto;
  text-align: center;
}
.img-down-formBtn {
  background: #ff9e00;
  width: 100px;
  height: 40px;
  color: #ffffff;
  border: none;
  font-size: 18px;
}
.img-camcale-formBtn {
  background: #cccccc;
  width: 100px;
  height: 40px;
  color: #ffffff;
  border: none;
  font-size: 18px;
}

/*搜索*/
.search-content {
  width: 970px;
  /*height: 102px;*/
  /*line-height: 102px;*/
  background: #FFFFFF;
  border-radius: 5px;
  /*padding: 10px;*/
  padding: 10px 10px 0;
  /*padding-bottom: 0.5px;*/
}
.search-letter {
  width: 970px;
  /*height: 10px;*/
  padding: 15px 10px;
  background: #FFFFFF;
  border-radius: 5px;
  margin-top: 10px;
}
.search-contentPer {
  width: 960px;
  height: 50px;
  line-height: 50px;
  background: #FFFFFF;
  border-radius: 5px;
  padding: 15px;
}
.search-content .el-select,
.search-content .el-cascader{
  margin-left: 20px;
}
.com-tips {
  padding: 25px 27px 28px 15px;
  background: #FFFFFF;
  /*margin-bottom: 5px;*/
  margin-top: 10px;
  border-radius: 5px;
}
.com-tips .prompt-info {
  height:30px;
  line-height:30px;
  color:#f47900;
  font-size:18px;
  padding-left: 0;
  font-weight:bold;
}
.com-tips .prompt-info span {
  color: #0071ff;
  cursor: pointer;
}

.choose-abc-active {
  color: #0071ff !important;
}
.workCity .el-input__inner {
  padding-right: 5px;
}
</style>
